/**
 * Created by claudio iozzia on 23/06/2017.
 */

import {Ic} from "./common";
import {IAppSpec} from "../Redux/selector.state";
import {ISingleOutput} from "./ISpec";
import {tassign} from "../common/utils";
import {Warning} from "./warning";

export type IUpdateDesignFn<T, U> = (value: T, spec: U) => T;
export type IUpdateDesignOutputFn<T, U, V, X> = (value: T, spec: U, out: V, i: X) => T;

export type UpdateDesignFn = IUpdateDesignFn<Ic, IAppSpec>;
export type UpdateDesignOutputFn = IUpdateDesignOutputFn<Ic, IAppSpec, ISingleOutput<number>, number>;

export type UpdateDesignCreator = (a: Ic) => IUpdateDesign;

export const UpdateDesignNone: UpdateDesignFn = (a: Ic, spec: IAppSpec): Ic => {
  return a;
};

export const UpdateDesignAllOutputNone: UpdateDesignOutputFn = (a: Ic, spec: IAppSpec, out: ISingleOutput<number>): Ic => {
  return a;
};

export function composeUpdateDesign(validators: UpdateDesignFn[]): UpdateDesignFn {

  return (t: Ic, u: IAppSpec) => validators.reduce(
    (acc: Ic, p: UpdateDesignFn) => {

      const _ic: Ic = p(t, u);
      return tassign(acc, _ic);
    }, t);
}

export function composeOutputUpdateDesign(validators: UpdateDesignOutputFn[]): UpdateDesignOutputFn {

  return (t: Ic, u: IAppSpec, o: ISingleOutput<number>, i: number) => validators.reduce(
    (acc: Ic, p: UpdateDesignOutputFn) => {

      const _ic: Ic = p(t, u, o, i);

      return tassign(acc, _ic);
    }
    , t
  );
}

export interface IUpdateDesign {
  updateDesign: UpdateDesignFn;
}

export class UpdateDesign implements IUpdateDesign {

  public static createUpdateDesign(a: Ic): IUpdateDesign {
    return new UpdateDesign();
  }

  protected updateDesign_Input(a: Ic, spec: IAppSpec): Ic {
    return a;
  }

  protected updateDesign_SingleOutput(a: Ic, spec: IAppSpec, out: ISingleOutput<number>, i: number): Ic {
    return a;
  }

  updateDesign(a: Ic, spec: IAppSpec): Ic {
    let _ic = a;
    _ic = tassign(_ic, this.updateDesign_Input(a, spec));

    spec.spec.value.output.outputs.forEach((x, i) => _ic = tassign(_ic, this.updateDesign_SingleOutput(_ic, spec, x, i)));

    return _ic;
  }
}
